import i18next from 'i18next'
/**
 * Returns formatted values by selected language
 * @param value
 */
const formatNumberByLocale = (
  value: string | number,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2
) => {
  return value || minimumFractionDigits
    ? i18next.t('intlNumber', {
        val: value || 0,
        minimumFractionDigits,
        maximumFractionDigits
      })
    : value
}

export default formatNumberByLocale
